const config = {
  "Group": {
    "EnrolmentFee": 200,
    "AdminFee": 0.005,
    "DepositoryFee": {
      "A": 10,
      "F": 10,
      "Y": 10,
      "N": 10,
      "M": 15,
      "P": 15,
      "X": 15,
      "O": 15,
      "T": 7
    }
  },
  "Self-Initiated": {
    "EnrolmentFee": 200,
    "AdminFee": 0.015,
    "DepositoryFee": {
      "A": 12,
      "M": 12,
      "T": 12
    }
  },
  "Achievers": {
    "EnrolmentFee": 55,
    "AdminFee": 0.0095,
    "DepositoryFee": {
      "A": 12,
      "M": 12,
      "Q": 12,
      "S": 12,
      "T": 12
    }
  }
}

export default config;